@if (checkedTickets) {
  <div class="managed-syndicate">
    <app-header pageTitle="{{ 'checked-managed-ticket.pageTitle' | translate }}" (back)="goBack()"></app-header>
    @if (ticketBaseInfo && ticketBaseInfo.checked_syndicates && ticketBaseInfo.checked_syndicates?.length) {
      <p class="syndicate-name"
        >
        {{'syndicate-tickets.name'| translate}}: {{ checkedTickets?.[index]?.syndicate_name }}
      </p>
    }
    @if (isEmptyTicket) {
      <div class="empty-ticket-wrapper">
        <p class="search-ic">🔎</p>
        <p class="no-checked-ticket">{{ "checked-managed-ticket.last" | translate }}</p>
      </div>
    }
    @if (!isEmptyTicket && checkedTickets) {
      <div>
        <div class="winning-result-wrapper">
          <h1>
            {{ checkedTickets?.[index]?.product_name }} {{ "checked-managed-ticket.Winning" | translate }}
            @if (checkedTickets?.[index]?.draw_round) {
              - {{ "checked-managed-ticket.Round" | translate }} {{ checkedTickets?.[index]?.draw_round }}
            }
          </h1>
          @if (ticketBaseInfo) {
            <p class="winning-date">
              {{translateMonthAbbreviation(checkedTickets[index]?.draw_date) }}
            </p>
          }
          <div class="numbers">
            <div class="number-space">
              @for (winResults of [checkedTickets[index]]; track winResults; let j = $index) {
                @if (winResults?.results) {
                  @if (winResults?.showLines) {
                    <ion-row class="checked-winresult-row ion-no-padding">
                      <div class="left-wrap">
                        @for (number of winResults?.results.regular; track number; let i = $index) {
                          <ion-col class="ion-no-padding">
                            <p class="regular-number">{{ number?.num }}</p>
                          </ion-col>
                        }
                        @for (number of winResults?.results.bonus; track number; let i = $index) {
                          <ion-col class="ion-no-padding">
                            <p class="bonus-number">{{ number?.num }}</p>
                          </ion-col>
                        }
                      </div>
                      <div class="right-wrap">
                        <ion-col class="ion-no-padding">
                          <p class="bonus-number winning-number">
                            {{currencySymbol}}{{((checkedTickets?.[index]?.results?.preferred_currency) ?
                            (checkedTickets?.[index].results?.preferred_currency?.value) :
                            (checkedTickets?.[index]?.results?.jackpot))}}
                          </p>
                        </ion-col>
                      </div>
                    </ion-row>
                  } @else {
                    @if (winResults.results?.raffle) {
                      @if (winResults.results.raffle?.[0]) {
                        <ion-row class="checked-raffle-row ion-no-padding r-width">
                          <ion-col class="left-sec ion-no-padding">
                            <span class="raffle-number">{{ winResults.results.raffle?.[0]?.raffle_num ?
                            winResults.results.raffle?.[0].raffle_num : "" }}</span>
                          </ion-col>
                          <ion-col class="right-sec ion-no-padding">
                            <span class="bonus-number winning-number">
                              {{currencySymbol}}{{ ((winResults.results.raffle?.[0]?.preferred_currency?.raffle_jackpot)
                              ? (winResults.results.raffle?.[0].preferred_currency?.raffle_jackpot) :
                            (winResults.results.raffle?.[0]?.raffle_jackpot)) }}</span>
                          </ion-col>
                        </ion-row>
                      }
                      @if (winResults.results?.raffle.length > 1) {
                        <div (click)="showMoreRaffle()" class="show-more-link">
                        More</div>
                      }
                      @if (showTooltip) {
                        <div class="tooltip-wrapper">
                          @for (winRaffle of winResults.results.raffle; track winRaffle) {
                            <div class="tooltip-main-box">
                              <div class="tooltip-content">
                                <h3 class="tooltip-title">
                                  {{ winRaffle?.raffle_num ? winRaffle.raffle_num : "" }}
                                </h3>
                                <p class="tooltip-desc">
                                  {{currencySymbol}}{{ ((winRaffle?.preferred_currency?.raffle_jackpot)
                                  ? (winRaffle.preferred_currency?.raffle_jackpot) :
                                  (winRaffle?.raffle_jackpot)) }}
                                </p>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    }
                  }
                }
              }
            </div>
          </div>
        </div>
        <swiper #swiperRef [config]="ticketSliderOptions" (slideChangeTransitionEnd)="slideChanged($event)"
          class="check-managed-ticket" id="checkedTicketsCard">
          @for (ticketInfo of checkedTickets; track ticketInfo; let infoIndex = $index) {
            <ng-template swiperSlide class="ticket-slide">
              <ion-card class="cardSlide">
                <ion-row class="jackpot-logo-wrapper">
                  <div class="jackpot-wrapper">
                    <div class="jackpot-logo-wrap">
                      <img class="jackpot-img" [src]="ticketInfo.product_image" alt="product-image" />
                    </div>
                    <div class="jackpot-name-wrap">
                      <h3 class="jackpot-name ion-text-left">{{ ticketInfo?.product_name }}</h3>
                      <p class="lines-available ion-text-left">
                        {{ translateDayAbbreviation(ticketInfo) }}
                        {{translateMonthAbbreviation(checkedTickets[index]?.draw_date) }}
                      </p>
                    </div>
                    <div class="jackpot-right-wrap">
                      <h1 class="txt-player">
                        {{ "checked-managed-ticket.Share" | translate }}
                      </h1>
                      <!-- <p
                      *ngIf="ticketInfo.viewText && !ticketInfo.dotAnimation"
                      class="player-number"
                      (click)="viewPlayers(infoIndex)"
                      >
                      View
                    </p>
                    <p *ngIf="!ticketInfo.viewText" class="player-numbers">
                      {{ syndicate_size && syndicate_size > 0 ? syndicate_size : "-" }}
                    </p> -->
                    <p class="player-numbers">
                      {{ ticketInfo?.syndicate_size && ticketInfo?.syndicate_size > 0 ? ticketInfo?.syndicate_size : "-" }}
                    </p>
                    @if (ticketInfo.dotAnimation) {
                      <app-dot-flash-animation></app-dot-flash-animation>
                    }
                  </div>
                </div>
                <div class="ticket-serial-numbers">
                  @for (winnings of ticketInfo.tickets; track winnings; let ticketRow = $index) {
                    <div class="ticket-row">
                      <div class="alphabet-wrapper">
                        @if (ticketInfo.syndicate_type === 'managed') {
                          <p>{{ winnings?.tkt_char }}</p>
                        }
                        @if (ticketInfo.syndicate_type !== 'managed' && winnings.ps_ticket_creator_profile_picture) {
                          <img
                            class="user-image" [src]="winnings.ps_ticket_creator_profile_picture"
                            onError="this.src='../../../assets/images/Group.png'" alt="users"
                            (click)="showProfilePopup(winnings?.user_id)" />
                        }
                        @if (ticketInfo.syndicate_type !== 'managed' && !winnings.ps_ticket_creator_profile_picture) {
                          <p
                            class="user-image">
                            {{ winnings.tkt_char }}
                          </p>
                        }
                      </div>
                      <div class="ticket-numbers-wrapper">
                        <ion-row class="ticket-number-wrap">
                          @if (ticketInfo.showLines) {
                            @for (ticket of winnings.regular; track ticket) {
                              <ion-col class="number-cols ion-no-padding">
                          <p class="opacity-ticket" [ngClass]="
                            checkRegularNumberLN(ticket.num, ticketInfo.results, infoIndex, winnings.tkt_char)
                          ">
                                  <span [ngClass]="isHighlighted ? 'ticket-cirle' : ''">{{ ticket.num }}</span>
                                </p>
                                <!--  <p
                                class="opacity-ticket"
                                [ngClass]="{ 'blue-cirle-ticket': ticket.match }"
                                *ngIf="!checkRegularNumber(ticket.num, ticketInfo.results)"
                                >
                                {{ ticket.num }}
                              </p> -->
                            </ion-col>
                          }
                          @for (ticket of winnings.bonus; track ticket) {
                            <ion-col class="number-cols ion-no-padding">
                              @if (checkBonusNumber(ticket.num, ticketInfo.results)) {
                                <p class="opacity-ticket yellow-circle-ticket"
                                  >
                                  {{ ticket.num }}
                                </p>
                              }
                              @if (!checkBonusNumber(ticket.num, ticketInfo.results)) {
                                <p class="opacity-ticket bonus-number" [ngClass]="{ 'yellow-circle-ticket': ticket.match }"
                                  >
                                  {{ ticket.num }}
                                </p>
                              }
                            </ion-col>
                          }
                        }
                        @if (!ticketInfo.showLines) {
                          <ion-col class="number-cols">
                            <p class="opacity-ticket" style="line-height: 1.5">
                              {{ winnings.raffle_num }}
                            </p>
                          </ion-col>
                        }
                      </ion-row>
                    </div>
                    @if (ticketInfo.showLines) {
                      <div class="winning-amount-wrap">
                        @if (winnings.win_type) {
                          <p class="winning-amount"><span>{{currencySymbol}}{{
                            ((winnings?.preferred_currency?.win_amount) ? (winnings?.preferred_currency?.win_amount | displayCurrency) : (winnings?.win_amount | displayCurrency)) }} </span></p>
                        }
                        @if (!winnings.win_type) {
                          <p class="winning-amount">-</p>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </ion-row>
            <ion-row class="total-lines-wrapper">
              <ion-col>
                <p class="total-lines">{{ "checked-managed-ticket.Total" | translate }}</p>
              </ion-col>
              <ion-col>
                <p class="no-of-lines">{{ ticketInfo.total_lines }} {{ "checked-managed-ticket.Line" | translate }}</p>
              </ion-col>
            </ion-row>
            @if (
              checkedTickets &&
              checkedTickets?.[index] &&
              checkedTickets?.[index]?.results &&
              checkedTickets?.[index]?.results?.raffle
              ) {
              <ion-row class="ticker-viwe-million">
                @if (ticketInfo.showLines) {
                  <p class="view-millionaire-makers" (click)="switchMode(infoIndex)">
                    {{ "checked-managed-ticket.View" | translate }}
                  </p>
                }
                @if (!ticketInfo.showLines) {
                  <p class="view-millionaire-makers" (click)="switchMode(infoIndex)">
                    {{ "checked-managed-ticket.lines" | translate }}
                  </p>
                }
              </ion-row>
            }
          </ion-card>
        </ng-template>
      }
    </swiper>
    <!-- Swiper Arrow Navigtion Start -->
    <div [ngClass]="checkedTickets.length == 1 ? 'pageButton_' : 'pageButton'">
      <div class="cardPager">
        <button (click)="slidePrev()" class="nav-prev-icon">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </button>
      </div>
      <div class="cardPager">
        <div class="swiper_pager"></div>
      </div>
      <div class="cardPager">
        <button (click)="slideNext()" class="nav-next-icon">
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </button>
      </div>
    </div>
    <!-- Swiper Arrow Navigtion End -->
  </div>
}
</div>
} @else {
  <app-in-progress-animation></app-in-progress-animation>
}
